<script setup>
  import { defineAsyncComponent } from "vue";

  // Definir os emits que o componente pode enviar para o pai
  const emit = defineEmits(['select-material']);

  const props = defineProps({
    product: Object, // Nota: Corrigido de Array para Object, já que parece ser um objeto único
    user: {
      type: Object,
      default: () => ({})
    }
  });

  const StockBadge = defineAsyncComponent(() => import("./StockBadge.vue"));

  // Função que dispara o evento para o componente pai
  const handleImageClick = () => {
    emit('select-material', props.product);
  };
</script>

<template>
  <div class="container-card-collec">
    <div class="stock-dot-badge-content">
      <StockBadge
        :product-name="product.name"
        :showStock="product.showStock"
        :user="user"
        :stock_type="product.stock_type"
        :stock="product.stock"
        :made_to_order="product.made_to_order"
        :dot="true"
      />
    </div>

    <!-- APLICADO APENAS AQUI: O @click agora está na imagem/container dela -->
    <div class="composite-image" v-if="product.packing_dimensions" @click="handleImageClick">
      <div class="ballon-tip">
        <img :src="product.featured_image.fullUrl" alt="">
      </div>
    </div>
    <div class="composite-image" v-else @click="handleImageClick">
      <img :src="product.featured_image.fullUrl" alt="">
    </div>

    <div class="composite-info">
      <p class="name">
        <a :href="product.slug">{{ product.reference }}</a>
      </p>
      <p class="reference">{{ product.packing_dimensions }}</p>
    </div>
  </div>
</template>

<style scoped>
  .composite-image {
    cursor: pointer;
  }
  .composite-info{
    .name{
      a{
        text-decoration: none;
        color: #000;
        &:hover{
          text-decoration: underline;
        }

      }
    }
  }
</style>
